module.exports = {
    SUBSCRIBE_SERVER_EVENT: 'SUBSCRIBE_SERVER_EVENT',
    SUBSCRIBE_SERVER_EVENTS: 'SUBSCRIBE_SERVER_EVENTS',
    UNSUBSCRIBE_SERVER_EVENT: 'UNSUBSCRIBE_SERVER_EVENT',
    UNSUBSCRIBE_SERVER_EVENTS: 'UNSUBSCRIBE_SERVER_EVENTS',
    START_EVENT_SOURCE_CONNECTION: 'START_EVENT_SOURCE_CONNECTION',
    START_EVENTS_SUBSCRIPTION: 'START_EVENTS_SUBSCRIPTION',
    CLOSE_EVENT_SOURCE_CONNECTION: 'CLOSE_EVENT_SOURCE_CONNECTION',
}
